export default __webpack_public_path__ + "static/media/stokvel-logo-avatar.d4721351.png";